<template>
  <div :class="buttonTypeBig ? 'action-holder-big' : showSelfSolvedButton ? 'action-holder-full' : 'action-holder'">
    <button
      type="button"
      class="btn"
      :class="buttonTypeBig ? 'btn-confirm-big' : 'btn-confirm-small'"
      @click="confirmTaught"
    >
      教えた
    </button>
    <button
      type="button"
      class="btn btn-blue"
      :class="buttonTypeBig ? 'btn-confirm-big' : 'btn-confirm-small'"
      @click="confirmGaveAHint"
    >
      ヒントをあげた
    </button>
    <button
      type="button"
      class="btn btn-red"
      :class="buttonTypeBig ? 'btn-confirm-big' : 'btn-confirm-small'"
      @click="confirmSelfSolved"
      v-show="showSelfSolvedButton"
    >
      考え終えていた
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: {
    askTeacher: {
      type: Object,
      required: true,
    },
    askTeachers: {
      type: Array,
      required: true,
    },
    showSelfSolvedButton: {
      type: Boolean,
      default: true,
    },
    buttonTypeBig: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    confirmTaught() {
      this.$logger.debug('Confirm taught Ask Teacher with Id: ' + this.askTeacher.id);
      let payload = {
        askTeachers: this.askTeachers,
        askTeacher: this.askTeacher,
      };
      this.replyTaughtAskTeacher(payload).then(() => {
        this.$emit('taughtClick');
      });
    },
    confirmGaveAHint() {
      this.$logger.debug('Confirm gave a hint for Ask Teacher with Id: ' + this.askTeacher.id);
      let payload = {
        askTeachers: this.askTeachers,
        askTeacher: this.askTeacher,
      };
      this.replyGaveAHintAskTeacher(payload).then(() => {
        this.$emit('gaveAHintClick');
      });
    },
    confirmSelfSolved() {
      this.$logger.debug('Confirm self solved for Ask Teacher with Id: ' + this.askTeacher.id);
      let payload = {
        askTeachers: this.askTeachers,
        askTeacher: this.askTeacher,
      };
      this.replyStudentSelfSolvedAskTeacher(payload).then(() => {
        this.$emit('selfSolvedClick');
      });
    },
    ...mapActions('ask_teacher', [
      'replyTaughtAskTeacher',
      'replyGaveAHintAskTeacher',
      'replyStudentSelfSolvedAskTeacher',
    ]),
  },
};
</script>

<style scoped>
.btn-red {
  background-color: #e75e58;
}
.btn-confirm-big {
  font-size: 13px;
  border: 1px;
  margin-left: 0px;
  margin-right: 10px;
  margin-bottom: 2px;
  padding: 5px 32px;
}
.btn-confirm-small {
  font-size: 10px;
  border: none;
  margin-left: 0px;
  margin-right: 2px;
  margin-bottom: 2px;
  padding: 5px 32px;
}
.action-holder-big {
  text-align: right;
}
.action-holder-full {
  width: 370px;
}
.action-holder {
  width: 240px;
}
</style>
